import { Badge } from "reactstrap";
import i18n from "../../../i18n";

export function printInvoiceStatus(status) {
  switch (status) {
    case 'draft':
      return <Badge color="secondary">{i18n.t('common.draft')}</Badge>;
    case 'sent':
      return <Badge color="info">{i18n.t('common.sent')}</Badge>;
    case 'partially_paid':
      return <Badge color="warning">{i18n.t('common.partiallyPaid')}</Badge>;
    case 'paid':
      return <Badge color="success">{i18n.t('common.paid')}</Badge>;
    case 'overdue':
      return <Badge color="danger">{i18n.t('common.overdue')}</Badge>;
    default:
      return <Badge color="dark">{i18n.t('common.unknownStatus')}</Badge>;
  }
}

export function printDeliveryNoteStatus(status) {
  switch (status) {
    case 'draft':
      return <Badge color="secondary">{i18n.t('common.draft')}</Badge>;
    case 'sent':
      return <Badge color="info">{i18n.t('common.sent')}</Badge>;
    case 'delivered':
      return <Badge color="success">{i18n.t('common.delivered')}</Badge>;
    case 'invoiced':
      return <Badge color="primary">{i18n.t('common.invoiced')}</Badge>;
    default:
      return <Badge color="dark">{i18n.t('common.unknownStatus')}</Badge>;
  }
}

export function printQuoteStatus(status) {
  switch (status) {
    case 'draft':
      return <Badge color="secondary">{i18n.t('common.draft')}</Badge>;
    case 'sent':
      return <Badge color="info">{i18n.t('common.sent')}</Badge>;
    case 'converted':
      return <Badge color="success">{i18n.t('common.converted')}</Badge>;
    case 'rejected':
      return <Badge color="danger">{i18n.t('common.rejected')}</Badge>;
    default:
      return <Badge color="dark">{i18n.t('common.unknownStatus')}</Badge>;
  }
}